module.exports = __webpack_public_path__ + "static/media/icon-auth-flow-1.ae53f3d6.png";